@if (isVisible) {
  <div class="work-ui-environment-ribbon">
    <div class="work-ui-environment-ribbon__band">
      <span class="work-ui-environment-ribbon__name">{{ environmentLabel }}</span>
      <span class="work-ui-environment-ribbon__suffix">{{ 'UMGEBUNG' | translate }}</span>
      <button (click)="openModal()"
              [attr.aria-label]="'UMGEBUNG_INFORMATIONEN' | translate"
              class="work-ui-environment-ribbon__info-button"
              [title]="'UMGEBUNG_INFORMATIONEN' | translate"
              type="button">
        <svg aria-hidden="true" focusable="false" height="15" viewBox="0 0 24 24" width="15">
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 4a1.4 1.4 0 1 1 0 2.8A1.4 1.4 0 0 1 12 6Zm1.3 11.5h-2.6v-7h2.6v7Z"
                fill="currentColor" />
        </svg>
      </button>
    </div>
  </div>

  @if (isModalOpen()) {
    <div (click)="closeModal()" class="work-ui-environment-modal">
      <div (click)="$event.stopPropagation()"
           aria-modal="true"
           class="work-ui-environment-modal__panel"
           role="dialog">
        <div class="work-ui-environment-modal__header">
          <h2 class="work-ui-environment-modal__title">{{ 'X_UMGEBUNG' | translate: { name: environmentLabel } }}</h2>
          <button (click)="closeModal()"
                  [attr.aria-label]="'SCHLIESSEN' | translate"
                  class="work-ui-environment-modal__close-button"
                  type="button">×</button>
        </div>

        <p [innerHTML]="'UMGEBUNG_HINWEIS_NICHT_PRODUKTIV' | translate: { name: environmentLabel }"></p>

        @if (appLinks.length > 0) {
          <h3 class="work-ui-environment-modal__subtitle">{{ 'UMGEBUNG_WEITERE_APPS' | translate }}</h3>
          <ul class="work-ui-environment-modal__links">
            @for (appLink of appLinks; track appLink.url) {
              <li><a [href]="appLink.url" rel="noopener" target="_blank">{{ appLink.label }}</a></li>
            }
          </ul>
        }

        <h3 class="work-ui-environment-modal__subtitle">{{ 'EMAILS_UND_SMS' | translate }}</h3>
        @if (isLoadingEnvironmentInfo()) {
          <p>{{ 'INFORMATIONEN_WERDEN_GELADEN' | translate }}</p>
        } @else if (hasEnvironmentInfoError()) {
          <p>{{ 'UMGEBUNG_VERSANDINFO_FEHLER' | translate }}</p>
        } @else if (environmentInfo(); as info) {
          <p>{{ 'UMGEBUNG_KEINE_ZUSTELLUNG' | translate }}</p>
          <ul class="work-ui-environment-modal__facts">
            <li>
              @if (info.mailFallbackAddresses.length > 0) {
                <span [innerHTML]="'UMGEBUNG_ALLE_EMAILS_AN' | translate: { addresses: mailFallbackAddressesText() }"></span>
              } @else {
                {{ 'UMGEBUNG_KEINE_EMAIL_UMLEITUNG' | translate }}
              }
            </li>
            <li>
              @if (info.smsFallbackPhoneNumber) {
                <span [innerHTML]="'UMGEBUNG_ALLE_SMS_AN' | translate: { number: info.smsFallbackPhoneNumber }"></span>
              } @else {
                {{ 'UMGEBUNG_KEINE_SMS_UMLEITUNG' | translate }}
              }
            </li>
          </ul>
        }
        <p class="work-ui-environment-modal__hint">
          {{ 'UMGEBUNG_UMLEITUNG_TICKET_HINWEIS' | translate }}
        </p>
      </div>
    </div>
  }
}
